import InstagramIcon from '@mui/icons-material/Instagram'
import HelpOutline from '@mui/icons-material/HelpOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Button, Link, Tooltip, Typography } from '@mui/material'
import { FC, MouseEventHandler, useState } from 'react'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'
import { ConnectInstagramAccountDialog } from './ConnectInstagramAccountDialog'

type HelpIconColor = 'white' | 'primary'

export const ConnectInstagramAccountButton: FC<{
  onClick: MouseEventHandler<HTMLButtonElement>
  helpIconColor?: HelpIconColor
}> = ({ onClick, helpIconColor = 'primary' }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Button variant="contained" onClick={onClick} startIcon={<InstagramIcon />}>
        Instagram連携を開始する
      </Button>
      <Link
        ml={1}
        mt={0.5}
        target="_blank"
        rel="noopener noreferrer"
        href={EXTERNAL_LINKS.INSTAGRAM_CONNECTION_INFO}
        aria-label="Instagram連携とは？"
      >
        <HelpOutline sx={{ color: helpIconColor }} />
      </Link>
      <Tooltip title={<Typography variant="subtitle2">無料でご利用いただけます</Typography>}>
        <InfoOutlinedIcon
          sx={{
            fontSize: '24px',
            color: helpIconColor,
            marginBottom: '2px',
          }}
        />
      </Tooltip>
    </Box>
  )
}

type Props = {
  showIntroStep?: boolean
  helpIconColor?: HelpIconColor
}

export const ConnectInstagramAccountButtonWithDialog: FC<Props> = ({ showIntroStep, helpIconColor }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleClose = () => setIsOpen(false)
  const handleOpen = () => setIsOpen(true)
  return (
    <>
      <ConnectInstagramAccountButton onClick={handleOpen} helpIconColor={helpIconColor} />
      <ConnectInstagramAccountDialog isOpen={isOpen} onClose={handleClose} showIntroStep={showIntroStep} />
    </>
  )
}
